import React, { useCallback, useEffect, useMemo, useState } from "react";
import * as XLSX from "xlsx";
import moment from 'moment';
import { CountryCode } from '../../config/CountryCode';
import { Translate as t } from '../../config/Translate';
const ensureXlsxExtension = (filename) => {
    if (!filename) return "export.xlsx";
    return filename.toLowerCase().endsWith('.xlsx') ? filename : `${filename}.xlsx`;
};

const getValueByPath = (item, path) => {
    if (!path) return "";
    return path.split('.').reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), item) ?? "";
};

const createRows = (items = [], headers = [], formatValue) => {
    const formatter = formatValue || ((value) => value ?? "");
    return items.map((item) => {
        const row = {};
        headers.forEach((header) => {
            const label = header.label || header.name || "";
            row[label] = formatter(getValueByPath(item, header.path || header.name), header, item);
        });
        return row;
    });
};

// IMP-446: named export — RayTable.js 가 컬럼 선택 모달 확인 시 cross-file import 로 직접 호출한다.
export const exportWorkbook = (data, formatValue) => {
    if (!data) return;
    const { items = [], headers = [], sheettitle, filename } = data;
    if (!items.length || !headers.length) return;

    const rows = createRows(items, headers, formatValue);
    const worksheet = XLSX.utils.json_to_sheet(rows, {
        header: headers.map((header) => header.label || header.name)
    });
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, (sheettitle && sheettitle.trim()) || "Sheet1");
    XLSX.writeFile(workbook, ensureXlsxExtension(filename));
};

export const ExportExcelClass = ({ data, css, disabled, title }) => {
    const [processing, setProcessing] = useState(false);
    const buttonClass = useMemo(() => css || "btn btn-lg btn-primary rayexport m-0", [css]);

    const handleExport = useCallback(() => {
        if (!data?.items?.length || !data?.headers?.length) return;
        setProcessing(true);
        try {
            exportWorkbook(data);
        } finally {
            setProcessing(false);
        }
    }, [data]);

    if (!data) {
        return null;
    }

    return (
        <button
            className={buttonClass}
            onClick={handleExport}
            disabled={processing || disabled}
        >
            {processing ? "Exporting..." : (title || t('common.button.export'))}
        </button>
    );
};

const formatWithMetadata = (value, header) => {
    if (!header) return value ?? "";
    if (header.type === "COUNTRY") {
        const matched = CountryCode.find((item) => item.code === value);
        return matched ? matched.title : value ?? "";
    }
    if (header.type === "DT") {
        return value ? moment(value).format("YYYY-MM-DD HH:mm:ss") : "";
    }
    return value ?? "";
};

export const ExportExcelHideElementClass = ({ data }) => {
    useEffect(() => {
        if (!data?.items?.length || !data?.headers?.length) return;
        exportWorkbook(data, (value, header, item) => {
            const resolvedValue = header?.name?.includes('.') ? getValueByPath(item, header.name) : value;
            return formatWithMetadata(resolvedValue, header);
        });
    }, [data]);

    return null;
};
